module.exports = __webpack_public_path__ + "images/aevitae_small133a112fd86cc805c1cb12fd6f36a504.png";